import React from 'react';
import { connect } from 'react-redux';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import Select from 'components/shared/select';
import { withTooltip } from 'components/shared/Tooltip';
import { routes } from 'constants/config';
import { hasFeature } from 'selectors/index';
import { Button, ButtonGroup, Icon } from 'ui';
import request from 'utils/request_ajax';
import CreateError from './CreateError';
import SelectWorkspace from './SelectWorkspace';

const preventLineBreaks = e => {
  if (e.key === 'Enter') e.preventDefault();
};

const recordingTypeToTitle = {
  webcam_recording: t(
    'practice.on_demand_practice.response_types.webcam_recording',
  ),
  screen_recording: t(
    'practice.on_demand_practice.response_types.screen_recording',
  ),
  audio_recording: t(
    'practice.on_demand_practice.response_types.audio_recording',
  ),
  written_response: t(
    'practice.on_demand_practice.response_types.written_response',
  ),
  conversation: t('practice.on_demand_practice.response_types.conversation'),
};

class ScenarioCreationModal extends React.Component {
  state = {
    title: '',
    description: '',
    recordingType: '',
    workspaceId: '',
    loading: false,
    createError: false,
  };

  createScenario = () => {
    const { title, description, workspaceId, recordingType } = this.state;
    const data = {
      container: {
        title,
        description,
        workspaceId,
      },
      scenario: {
        prompt: '',
        scenarioType: recordingType,
      },
    };

    request
      .post(routes.ON_DEMAND_PRACTICE.CREATOR.INDEX, data)
      .then(createData => {
        if (createData.success) {
          window.location.assign(
            routes.ON_DEMAND_PRACTICE.CREATOR.EDIT(
              createData.practice_scenario_id,
            ),
          );
        } else {
          this.setState({
            createError: true,
            loading: false,
          });
        }
      })
      .fail(() => {
        this.setState({
          createError: true,
          loading: false,
        });
      });
  };

  handleInputChange = e => {
    const { name } = e.target;
    let { value } = e.target;
    if (name === 'description') {
      value = value.replace(/\r?\n|\r/g, ' ');
    }
    this.setState({ [name]: value });
  };

  dismissCreateError = () => {
    this.setState({
      createError: false,
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ loading: true }, this.createScenario);
  };

  hasChosenRecordingType = () => {
    if (this.props.features.allRecordingTypes) {
      return this.state.recordingType.length > 0;
    }
    // If hasAllRecordingTypes is false, we want to make the submit button not disabled
    return true;
  };

  render() {
    const { title, description, loading, createError } = this.state;
    const { practiceScenarioTypes, workspaces, features, closeModal } =
      this.props;
    const canAssignWorkspace = features.workspaces && workspaces.length > 1;
    const hasAllRecordingTypes = features.allRecordingTypes;
    return (
      <>
        <RenderInBody>
          <ModalContainer
            onEscape={closeModal}
            className="ModalTakeover-background Modal-background d-f ai-c"
          >
            <div className="ModalTakeover-container ScenarioCreationModal">
              <form
                onSubmit={this.handleSubmit}
                className="ScenarioCreationModal-body"
              >
                <div className="ScenarioCreationModal-title">
                  {t('practice.on_demand_practice.create_modal.new_scenario')}
                </div>
                <div className="ScenarioCreationModal-subtitle">
                  {t('practice.on_demand_practice.create_modal.description')}
                </div>
                <label
                  htmlFor="title"
                  className="ScenarioCreationModal-inputTitle"
                >
                  {t('common.title')}
                </label>
                <input
                  id="title"
                  name="title"
                  className="NewInput NewInput--white NewInput--fw ModalTakeover-nameInput"
                  placeholder={t('common.enter_title')}
                  type="text"
                  onChange={this.handleInputChange}
                  value={title}
                  maxLength="255"
                />
                <label
                  htmlFor="description"
                  className="ScenarioCreationModal-inputTitle"
                >
                  {t('common.description')}
                </label>
                <textarea
                  id="description"
                  name="description"
                  className="NewInput NewInput--white NewInput--fw"
                  placeholder={t('common.enter_description')}
                  rows="3"
                  onChange={this.handleInputChange}
                  onKeyDown={preventLineBreaks}
                  value={description}
                />
                {hasAllRecordingTypes && (
                  <div>
                    <label
                      htmlFor="recordingType"
                      className="ScenarioCreationModal-inputTitle"
                    >
                      {t(
                        'practice.on_demand_practice.create_modal.response_type',
                      )}
                    </label>
                    <Select
                      name="recordingType"
                      id="recordingType"
                      onChange={this.handleInputChange}
                      fullWidth
                    >
                      <option value="">
                        {t(
                          'practice.on_demand_practice.create_modal.enter_response_type',
                        )}
                      </option>
                      {practiceScenarioTypes.map(option => (
                        <option key={option} value={option}>
                          {recordingTypeToTitle[option]}
                        </option>
                      ))}
                    </Select>
                  </div>
                )}
                {canAssignWorkspace && (
                  <div>
                    <SelectWorkspace
                      workspaces={workspaces}
                      onChange={this.handleInputChange}
                    />
                  </div>
                )}
                <ButtonGroup alignEnd className="mt-32">
                  {withTooltip({
                    text: !this.hasChosenRecordingType()
                      ? t(
                          'practice.on_demand_practice.create_modal.response_type_error',
                        )
                      : '',
                  })(
                    <Button
                      customColor
                      submit
                      loading={loading}
                      disabled={!this.hasChosenRecordingType()}
                    >
                      {t(
                        'practice.on_demand_practice.create_modal.create_scenario',
                      )}
                    </Button>,
                  )}
                </ButtonGroup>
              </form>
              <button
                type="button"
                className="u-resetBtn ModalTakeover-closeButton"
                aria-label={t('common.close')}
                onClick={closeModal}
              >
                <Icon name="error" />
              </button>
            </div>
          </ModalContainer>
        </RenderInBody>
        {createError && (
          <CreateError
            createType="scenario"
            onDismiss={this.dismissCreateError}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  features: {
    workspaces: hasFeature(state, 'workspaces'),
    allRecordingTypes: hasFeature(state, 'on_demand_practice'),
  },
  workspaces: state.data.meta.workspaceOptions,
  practiceScenarioTypes: state.data.meta.practiceScenarioTypes,
  portableScenarioTypes: state.data.meta.portableScenarioTypes,
});

export default connect(mapStateToProps)(ScenarioCreationModal);
